module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"update":"Update","updateAvailable":"An update is available"},"es":{"update":"Actualizar","updateAvailable":"Hay una actualización disponible"},"sw":{"update":"Sasisha","updateAvailable":"Sasisho linapatikana"}}')
  delete Component.options._Ctor
}
